import { api } from '@/constants'
import { getAuthHeader, serializeQueryParams } from '@/util'
import baseURL from '@/service/api'

const role = {
  permissionList: params => {
    const url = api.role.permissionList + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  roleList: params => {
    const url = api.role.roles + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  roleDetail: id => {
    const url = api.role.roleDetail(id)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  createRole: payloads => {
    const url = api.role.roles
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  }
}
export default role
